import {observer} from "mobx-react";
import {pmsDetailStore, validationStore} from "../../../store";
import {PmsForm, PmsFormValidation} from "./PmsForm";
import {Page, PageContentTitle} from "../../ui";

const PmsDetailPage = observer(function PmsDetailPage() {

    const validation: PmsFormValidation = {
        type: validationStore.getFor('type'),
        name: validationStore.getFor('name'),
        displayName: validationStore.getFor('displayName')
    }

    const display = `${pmsDetailStore.displayName || ''} (${pmsDetailStore.name})`

    return <Page
        breadcrumb={[
            {
                link: '/pms',
                label: 'Druckerverwaltung'
            },
            {
                link: `/pms/${pmsDetailStore.id}`,
                label: display
            }
        ]}
    >

        <PageContentTitle
            actions={[
                {
                    label: 'Änderungen verwerfen',
                    disabled: !pmsDetailStore.dirty,
                    action: () => pmsDetailStore.reset()
                },
                {
                    label: 'Speichern',
                    cls: 'is-primary',
                    disabled: !pmsDetailStore.dirty || !pmsDetailStore.valid,
                    action: async () => await pmsDetailStore.save()
                }
            ]}
        >{display}</PageContentTitle>
        <PmsForm
            validation={validation}
            data={pmsDetailStore.formData}
            onChange={data => pmsDetailStore.formData = data}
            onBlur={() => pmsDetailStore.validate()}
        />
    </Page>
})

export {
    PmsDetailPage
}
